const etMinutes = () => {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/New_York',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).formatToParts(new Date());
  const values = Object.fromEntries(parts.map(p => [p.type, p.value]));
  return Number(values.hour || 0) * 60 + Number(values.minute || 0);
};

export const getSessionPhase = (isTradingSession = true) => {
  if (!isTradingSession) {
    return { key: 'CLOSED', label: 'MARKET CLOSED', action: 'Review research and prepare the next-session watchlist.' };
  }
  const mins = etMinutes();
  if (mins < 8 * 60) {
    return { key: 'PREMARKET', label: 'PRE-MARKET', action: 'Build context: regime, themes and daily leaders.' };
  }
  if (mins < 9 * 60 + 30) {
    return { key: 'PREP', label: 'PRE-OPEN', action: 'Finalize the focus list and verify execution readiness.' };
  }
  if (mins < 9 * 60 + 36) {
    return { key: 'OPENING', label: 'OPENING BUILD', action: 'Wait for the first five-minute confirmation. Do not chase.' };
  }
  if (mins < 16 * 60) {
    return { key: 'LIVE', label: 'LIVE SESSION', action: 'Focus only on names that clear RVOL and strategy-fit gates.' };
  }
  if (mins < 20 * 60) {
    return { key: 'POST', label: 'POST-MARKET', action: 'Review fills, R, MFE/MAE and prepare tomorrow’s watchlist.' };
  }
  return { key: 'CLOSED', label: 'MARKET CLOSED', action: 'Review research and prepare the next-session watchlist.' };
};
